/**
 * t378u: the trial / payment banner, for Owners and Admins of self-serve workspaces only ("12 days left in your free
 * trial · Subscribe"). Enterprise workspaces and everyone else never see it. Text comes from billingBanner() in
 * @tradeoutlet/shared so web and mobile say the same thing.
 */
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { billingBanner, BILLING_PERMISSION } from '@tradeoutlet/shared';
import { useCan } from '@/lib/permissions';
import { useBilling } from './hooks';

export const BILLING_PATH = '/settings/workspace/billing';

export function BillingBanner() {
  const canManage = useCan(BILLING_PERMISSION);
  const q = useBilling(canManage);
  const { pathname } = useLocation();
  const b = canManage ? billingBanner(q.data) : null;
  if (!b) return null;
  const tone = { info: 'border-sky-200 bg-sky-50 text-sky-900 dark:border-sky-900 dark:bg-sky-950 dark:text-sky-100',
    warning: 'border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-100',
    danger: 'border-red-200 bg-red-50 text-red-900 dark:border-red-900 dark:bg-red-950 dark:text-red-100' }[b.tone];
  return (
    <div role={b.tone === 'danger' ? 'alert' : 'status'} data-testid="billing-banner"
      className={clsx('flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-b px-4 py-2 text-center text-sm', tone)}>
      <span>{b.text}</span>
      {pathname !== BILLING_PATH && (
        <Link to={BILLING_PATH} className="font-semibold underline underline-offset-2">{b.action === 'update_card' ? 'Update payment details' : 'Subscribe'}</Link>
      )}
    </div>
  );
}
